import React, { useContext } from "react";
import PropTypes from "prop-types";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";
import SelectableSection from "./SelectableSection";
import SelectableElement from "./SelectableElement";
import ValuePlaceholder from "./ValuePlaceholder";

const SellerSectionViewer = ({ invoiceData }) => {
  const { showValuePlaceHolder } = useContext(InvoiceTemplateContext);
  const { qrCode, bilingualEnabled, sellerSection } = invoiceData;

  return (
    <SelectableSection
      section="sellerSection"
      isSelectable={sellerSection.isSelectable}
    >
      <table width="100%">
        <tbody>
          <tr>
            <td>
              {sellerSection.fields
                .filter(field => field.visible)
                .map((field, index) => (
                  <div
                    key={index}
                    style={{ display: "inline-flex", ...field.style }}
                  >
                    <SelectableElement
                      as="span"
                      id={`sellerSection.fields[${index}].label.vi`}
                      stylePath={`sellerSection.fields[${index}].labelStyle.vi`}
                      style={field.labelStyle.vi}
                    >
                      {field.label.vi}
                    </SelectableElement>
                    {bilingualEnabled && (
                      <SelectableElement
                        as="span"
                        id={`sellerSection.fields[${index}].label.en`}
                        stylePath={`sellerSection.fields[${index}].labelStyle.en`}
                        style={field.labelStyle.en}
                      >
                        &nbsp;{field.label.en}
                      </SelectableElement>
                    )}
                    <SelectableElement
                      as="span"
                      id={`sellerSection.fields[${index}].delimiter`}
                      stylePath={`sellerSection.fields[${index}].delimiterStyle`}
                      style={field.delimiterStyle}
                    >
                      {field.delimiter}{" "}
                    </SelectableElement>
                    <SelectableElement
                      as="span"
                      id={`sellerSection.fields[${index}].value`}
                      stylePath={`sellerSection.fields[${index}].valueStyle`}
                      style={field.valueStyle}
                    >
                      <ValuePlaceholder placeholderKey={field.name}>
                        {field.value}
                      </ValuePlaceholder>
                    </SelectableElement>
                  </div>
                ))}

              {sellerSection.fields.filter(field => field.visible).length <=
                0 && <div className="my-2"></div>}
            </td>
            {qrCode.enabled && (
              <td>
                <div className="qr-code-container">
                  {!showValuePlaceHolder && (
                    <img src={qrCode.url} style={qrCode.style} />
                  )}
                  <ValuePlaceholder placeholderKey="qr_code"></ValuePlaceholder>
                </div>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </SelectableSection>
  );
};

SellerSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default SellerSectionViewer;
